import React from "react";

/**
 * Checkbox grid for choosing which fields the query returns.
 * @param {object} props
 * @param {Array<{key: string, label: string}>} props.fields the module's fields.
 * @param {string[]} props.selected the selected field keys.
 * @param {(key: string) => void} props.onToggle toggles a field's selection.
 * @returns {JSX.Element|null}
 */
export default function FieldSelector({ fields, selected, onToggle }) {
  if (!fields.length) return null;
  return (
    <div className="qb-field">
      <span className="qb-label">Filters</span>
      <div className="qb-checkbox-grid">
        {fields.map((field) => (
          <label key={field.key} className="qb-checkbox">
            <input
              type="checkbox"
              checked={selected.includes(field.key)}
              onChange={() => onToggle(field.key)}
            />
            <span>{field.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
